import { Injectable, ViewContainerRef } from '@angular/core';
import moment from 'moment';
import { DmpHlFindPatientParams, DmpSexEnum } from 'src/app/utils/interfaces/new/dmp-hl-find-patient-params.interface';
import { DmpHlFindPatientResponse, DmpHlFindPatientResponseSIns, FindPatientResponseGender } from 'src/app/utils/interfaces/new/dmp-hl-find-patient-response.interface';
import { DmpHlGetCertifiedIdentityParams } from 'src/app/utils/interfaces/new/dmp-hl-get-certified-identity-params.interface';
import { DmpHlGetCertifiedIdentityResponse } from 'src/app/utils/interfaces/new/dmp-hl-get-certified-identity-response.interface';
import { DmpHlGetDirectAuthentificationDmpStatus, DmpStatusEnum, DmpUserAuthorizationEnum } from 'src/app/utils/interfaces/new/dmp-hl-get-direct-authentification-dmp-status.interface';
import { DmpHlGetInteropCodesEnum } from 'src/app/utils/enums/dmp-hl-get-interop-codes-params.enum';
import { DmpHlGetInteropCodesResponse } from 'src/app/utils/interfaces/new/dmp-hl-get-interop-codes-response.interface';
import { DmpHlGetWebPsUrlsResponse } from 'src/app/utils/interfaces/new/dmp-hl-get-web-ps-urls-response.interface';
import { DmpHlUpdateUserAccessAuthorizationParams } from 'src/app/utils/interfaces/new/dmp-hl-update-user-access-authorization-identity-params.interface';
import { CpxHandleMockService } from '../cpx-handle/cpx-handle-mock.service';
import { DmpParameters, DmpServiceAbstract, UpdateNoteVaccinationId, ValidationVaccination, VaccinationConsumable, VaccinationVaccinator } from './dmp-service.abstract';
import { DmpHlFindDocumentsParams } from 'src/app/utils/interfaces/new/dmp-hl-find-documents-params.interface';
import { DmpHlFindDocumentsResponse } from 'src/app/utils/interfaces/new/dmp-hl-find-documents-response.interface';
import { DmpFormatEnum } from 'src/app/utils/enums/dmp-format.enum';
import { DmpStatusEnum as DmpStatusEnumMain } from 'src/app/utils/enums/dmp-status.enum';
import { DmpVisibilityEnum } from 'src/app/utils/enums/dmp-visibility.enum';
import { DmpHlGetDocumentContentParams } from 'src/app/utils/interfaces/new/dmp-hl-get-document-content-params.interface';
import { DmpHlGetDocumentContentResponse } from 'src/app/utils/interfaces/new/dmp-hl-get-document-content-response.interface';
import { DmpHlDeleteDocumentParams } from 'src/app/utils/interfaces/new/dmp-hl-delete-document-params.interface';
import { DmpHlsendDocumentsParams, DmpHlsendDocumentsDocument } from 'src/app/utils/interfaces/new/dmp-hl-send-documents-params.interface';
import { DmpHlAccessModeEnum, DmpHlSetDmpAccessModeParams } from 'src/app/utils/interfaces/new/dmp-hl-set-dmp-access-mode-params.interface';
import { CpxHandleServiceAbstract } from '../cpx-handle/cpx-handle-service-abstract';
import { DmpHlArchiveDocumentParams } from 'src/app/utils/interfaces/new/dmp-hl-archive-document-params.interface';
import { DmpGetMyDocumentsParams } from 'src/app/utils/interfaces/new/dmp-get-my-documents-params.interface';
import { DmpGetMyDocumentsResult } from 'src/app/utils/interfaces/new/dmp-get-my-documents-result.interface';
import { DmpHlVisibilityDocumentParams } from 'src/app/utils/interfaces/new/dmp-hl-visibility-document-params.interface';
import { DmpGetLastAccessDateParams } from 'src/app/utils/interfaces/new/dmp-get-last-access-date-params.interface';
import { DmpAddMyDocumentsParams } from 'src/app/utils/interfaces/new/dmp-add-my-documents-params.interface';

declare const DMPConnect: any;

@Injectable({
  providedIn: 'root'
})
export class DmpMockService extends DmpServiceAbstract {
  accessMode: DmpHlAccessModeEnum;
  getLastAccessDate(lastAccessParams: DmpGetLastAccessDateParams): Promise<Date> {
    throw new Error('Method not implemented.');
  }
  setLastAccessDate(lastAccessParams: DmpGetLastAccessDateParams): Promise<void> {
    throw new Error('Method not implemented.');
  }
  deleteNoteDeVaccination(view: ViewContainerRef, deleteParams: DmpHlDeleteDocumentParams): Promise<void> {
    throw new Error('Method not implemented.');
  }
  deleteFromMyDocuments(uniqueId: string): Promise<void> {
    throw new Error('Method not implemented.');
  }
  updateVisibilityDocumentByUniqueId(view: ViewContainerRef, archiveParams: DmpHlVisibilityDocumentParams): Promise<void> {
    throw new Error('Method not implemented.');
  }
  getMyDocuments(myDocsParams: DmpGetMyDocumentsParams): Promise<DmpGetMyDocumentsResult[]> {
    throw new Error('Method not implemented.');
  }
  archiveDocumentByUniqueId(view: ViewContainerRef, archiveParams: DmpHlArchiveDocumentParams): Promise<void> {
    throw new Error('Method not implemented.');
  }
  getConfidentialityLevel(view: ViewContainerRef): Promise<boolean> {
    throw new Error('Method not implemented.');
  }
  setConfidentialityLevel(view: ViewContainerRef, enable: boolean): Promise<void> {
    throw new Error('Method not implemented.');
  }
  getDmpParameters(view: ViewContainerRef): Promise<DmpParameters> {
    throw new Error('Method not implemented.');
  }
  getMajorityAge(view: ViewContainerRef): Promise<number> {
    throw new Error('Method not implemented.');
  }
  getVaccinationContent(view: ViewContainerRef, documentHandle: number): Promise<any> {
    throw new Error('Method not implemented.');
  }
  validerVaccin(view: ViewContainerRef, sendingParam: DmpHlsendDocumentsParams, vaccin: ValidationVaccination, patientId?: string): Promise<void> {
    throw new Error('Method not implemented.');
  }
  addMyDocuments(myDocsParams: DmpAddMyDocumentsParams, uniqueId?: string): Promise<void> {
    throw new Error('Method not implemented.');
  }
  updateMyDocumentsDocumentId(uniqueId: string, documentId: string): Promise<void> {
    throw new Error('Method not implemented.');
  }
  searchDMPDocumentByDocumentId(list: string[]): Promise<{ documentDmp: DmpGetMyDocumentsResult; documentId: string; }[]> {
    throw new Error('Method not implemented.');
  }

  public resourceId: string;
  public practiceSettingIndice: number;

  constructor(
    private _cvMockSrv: CpxHandleServiceAbstract
  ) { super(); }

  private _patientsResponse: Array<DmpHlFindPatientResponse> = [
    {
      CivilStatus: {
        i_gender: FindPatientResponseGender['Civilité inconnue'],
        s_given: 'Toto',
        s_name: 'Tata'
      },
      Ins: {
        s_ins: '123456789',
        s_insType: 'T'
      },
      i_matchingPercentage: 12,
      i_sex: DmpSexEnum.Indéterminé,
      s_birthDay: new Date(),
      s_birthName: 'Titi',
      s_city: 'Night City',
      s_insC: '123456789T',
      s_postalCode: '00000'
    },
    {
      CivilStatus: {
        i_gender: FindPatientResponseGender.Mr,
        s_given: 'Georges',
        s_name: 'Brassens'
      },
      Ins: {
        s_ins: '234567891',
        s_insType: 'T'
      },
      i_matchingPercentage: 12,
      i_sex: DmpSexEnum.Masculin,
      s_birthDay: new Date(),
      s_birthName: 'Brassens',
      s_city: 'Sète',
      s_insC: '234567891T',
      s_postalCode: '34200'
    }
  ];

  public async hl_getdirectauthentificationdmpstatus(view: ViewContainerRef, patientIns: string): Promise<DmpHlGetDirectAuthentificationDmpStatus> {
    // Paramétrage mock pour tester les différents statuts possibles
    const mockDmpExists = DmpStatusEnum['DMP existant'];
    const mockAuthorization = false;

    return new Promise<DmpHlGetDirectAuthentificationDmpStatus>(async (resolve, reject) => {
      try {
        await this._fakeAwait();
        const vitalePatients = [...(this._cvMockSrv as CpxHandleMockService).mockVitaleCase];
        for (const vp of vitalePatients) {
          for (const p of vp.Patients) {
            if (p.s_insC === '0972846792913992566602') {
              resolve({
                ExistingTestAnswer: {
                  AdminData: {
                    Ins: {
                      s_ins: patientIns,
                      s_insType: 'T'
                    },
                    s_birthday: moment(p.s_birthday, 'DDMMYYYY').toDate(),
                    s_insC: p.s_insC,
                    s_patientBirthName: p.s_birthname,
                    s_patientGivenName: p.s_given,
                    s_patientName: p.s_name,
                    s_patientFirstBirthGiven: ''
                  },
                  i_dmpStatus: mockDmpExists,
                  i_ensRelatedDmp: true,
                  i_sex: DmpSexEnum.Indéterminé,
                  i_userAuthorization: DmpUserAuthorizationEnum['Non autorisé'],
                  i_webAccessIsOpen: true
                },
                i_treatingPhysician: true,
                s_mail: 'mock@test.net',
                s_mobilePhone: '0254786515',
                s_status: 'OK'
              });
            }
          }
        }
      } catch (e) {
        reject(e);
      }
    });
  }

  public async hl_updateuserdmpaccessauthorization(view: ViewContainerRef, authorizationParams: DmpHlUpdateUserAccessAuthorizationParams): Promise<void> {
    return new Promise<void>(async (resolve, reject) => {
      try {
        await this._fakeAwait();
        resolve();
      } catch (e) {
        reject(e);
      }
    });
  }

  public async hl_setdmpaccessmode(view: ViewContainerRef, accessMode: DmpHlSetDmpAccessModeParams): Promise<void> {
    return new Promise<void>(async (resolve, reject) => {
      try {
        await this._fakeAwait();
        resolve();
      } catch (e) {
        reject(e);
      }
    });
  }

  public async hl_getwebpsdmpurls(view: ViewContainerRef, sIns: DmpHlFindPatientResponseSIns): Promise<DmpHlGetWebPsUrlsResponse> {
    return new Promise<DmpHlGetWebPsUrlsResponse>(async (resolve, reject) => {
      try {
        await this._fakeAwait();
        resolve({
          Urls: [
            'https://www.google.fr'
          ]
        });
      } catch (e) {
        reject(e);
      }
    });
  }

  public async hl_getInteropCodes(view: ViewContainerRef, sCodeIds: DmpHlGetInteropCodesEnum[]): Promise<DmpHlGetInteropCodesResponse> {
    return new Promise<DmpHlGetInteropCodesResponse>(async (resolve, reject) => {
      try {
        await this._fakeAwait();
        resolve({
          docTypes: [{
            s_code: 'RADIOGRAPHIE',
            s_codeSystem: '1.2.250.1.213.1.1.4.9',
            s_displayName: 'Radiographie'
          }, {
            s_code: 'PRESCRIPTION',
            s_codeSystem: '1.2.250.1.213.1.1.4.9',
            s_displayName: 'Prescription'
          }, {
            s_code: 'PRISE DE SANG',
            s_codeSystem: '1.2.250.1.213.1.1.4.9',
            s_displayName: 'Prise de sang'
          }],
          docFormats: [{
            s_code: 'PDF',
            s_codeSystem: '1.2.250.1.213.1.1.4.9',
            s_displayName: 'PDF'
          }, {
            s_code: 'JPEG',
            s_codeSystem: '1.2.250.1.213.1.1.4.9',
            s_displayName: 'Jpeg'
          }, {
            s_code: 'MP4',
            s_codeSystem: '1.2.250.1.213.1.1.4.9',
            s_displayName: 'Mp4'
          }]
        });
      } catch (e) {
        reject(e);
      }
    });
  }

  public async hl_finddocuments(view: ViewContainerRef, ins: DmpHlFindPatientResponseSIns, searchParams: DmpHlFindDocumentsParams): Promise<Array<DmpHlFindDocumentsResponse>> {
    return new Promise<Array<DmpHlFindDocumentsResponse>>(async (resolve, reject) => {
      try {
        await this._fakeAwait();
        console.log('searchParams : ', searchParams);
        resolve([{
          Authors: [{
            s_hpGiven: 'Gregory',
            s_hpName: 'House',
            s_hpInstitution: 'Hôpital De Nantes',
            s_hpInternalId: '987654321',
            s_hpProfession: 'Médecin',
            s_hpProfessionDescription: 'Soigne les gens',
            s_hpProfessionOid: '1.2.250.1.71.1.2.7',
            s_hpSpeciality: 'Tout',
            s_hpSpecialityDescription: 'DrHouse peut tout soigner'
          }],
          EventCodes: [],
          i_document_Format: DmpFormatEnum['Document RichText au format RTF'],
          i_document_Status: DmpStatusEnumMain['Courant'],
          i_document_Visibility: DmpVisibilityEnum['Le document est visible de tous'],
          i_handle: 321654987,
          s_classCode: '654321987',
          s_creationDate: new Date(),
          s_description: '',
          s_healthCareFacilityTypeCode: '789456123',
          s_nextUuid: '123456789',
          s_practiceSettingCode: '654123987',
          s_previousUuid: '123456787',
          s_serviceStartDate: new Date(),
          s_serviceStopDate: new Date(),
          s_submissionDate: new Date(),
          s_title: 'Jambe cassée',
          s_typeCode: '654321987',
          s_uniqueId: '123456788',
          s_uuid: '123456788',
          s_documentFormatCode: '',
          s_documentFormatDescription: '',
          s_submissionSetId: ''
        }, {
          Authors: [{
            s_hpGiven: 'Gregory',
            s_hpName: 'House',
            s_hpInstitution: 'Hôpital De Nantes',
            s_hpInternalId: '987654321',
            s_hpProfession: 'Médecin',
            s_hpProfessionDescription: 'Soigne les gens',
            s_hpProfessionOid: '1.2.250.1.71.1.2.7',
            s_hpSpeciality: 'Tout',
            s_hpSpecialityDescription: 'DrHouse peut tout soigner'
          }],
          EventCodes: [],
          i_document_Format: DmpFormatEnum['Document RichText au format RTF'],
          i_document_Status: DmpStatusEnumMain['Courant'],
          i_document_Visibility: DmpVisibilityEnum['Le document est visible de tous'],
          i_handle: 321654987,
          s_classCode: '654321987',
          s_creationDate: new Date(),
          s_description: '',
          s_healthCareFacilityTypeCode: '789456123',
          s_nextUuid: '123456789',
          s_practiceSettingCode: '654123987',
          s_previousUuid: '123456787',
          s_serviceStartDate: new Date(),
          s_serviceStopDate: new Date(),
          s_submissionDate: new Date(),
          s_title: 'Jambe cassée 2',
          s_typeCode: '654321987',
          s_uniqueId: '123456788sf',
          s_uuid: '123456788',
          s_documentFormatCode: '',
          s_documentFormatDescription: '',
          s_submissionSetId: ''
        }, {
          Authors: [{
            s_hpGiven: 'Gregory',
            s_hpName: 'House',
            s_hpInstitution: 'Hôpital De Nantes',
            s_hpInternalId: '987654321',
            s_hpProfession: 'Médecin',
            s_hpProfessionDescription: 'Soigne les gens',
            s_hpProfessionOid: '1.2.250.1.71.1.2.7',
            s_hpSpeciality: 'Tout',
            s_hpSpecialityDescription: 'DrHouse peut tout soigner'
          }],
          EventCodes: [],
          i_document_Format: DmpFormatEnum['Document RichText au format RTF'],
          i_document_Status: DmpStatusEnumMain['Courant'],
          i_document_Visibility: DmpVisibilityEnum['Le document est visible de tous'],
          i_handle: 321654987,
          s_classCode: '654321987',
          s_creationDate: new Date(),
          s_description: '',
          s_healthCareFacilityTypeCode: '789456123',
          s_nextUuid: '123456789',
          s_practiceSettingCode: '654123987',
          s_previousUuid: '123456787',
          s_serviceStartDate: new Date(),
          s_serviceStopDate: new Date(),
          s_submissionDate: new Date(),
          s_title: 'Jambe cassée 3',
          s_typeCode: '654321987',
          s_uniqueId: '12345678dsfqs8',
          s_uuid: '123456788',
          s_documentFormatCode: '',
          s_documentFormatDescription: '',
          s_submissionSetId: ''
        }, {
          Authors: [{
            s_hpGiven: 'Gregory',
            s_hpName: 'House',
            s_hpInstitution: 'Hôpital De Nantes',
            s_hpInternalId: '987654321',
            s_hpProfession: 'Médecin',
            s_hpProfessionDescription: 'Soigne les gens',
            s_hpProfessionOid: '1.2.250.1.71.1.2.7',
            s_hpSpeciality: 'Tout',
            s_hpSpecialityDescription: 'DrHouse peut tout soigner'
          }],
          EventCodes: [],
          i_document_Format: DmpFormatEnum['Document RichText au format RTF'],
          i_document_Status: DmpStatusEnumMain['Courant'],
          i_document_Visibility: DmpVisibilityEnum['Le document est visible de tous'],
          i_handle: 321654987,
          s_classCode: '654321987',
          s_creationDate: new Date(),
          s_description: '',
          s_healthCareFacilityTypeCode: '789456123',
          s_nextUuid: '123456789',
          s_practiceSettingCode: '654123987',
          s_previousUuid: '123456787',
          s_serviceStartDate: new Date(),
          s_serviceStopDate: new Date(),
          s_submissionDate: new Date(),
          s_title: 'Jambe cassée 4',
          s_typeCode: '654321987',
          s_uniqueId: '12345678dsqsdfdfqs8',
          s_uuid: '123456788',
          s_documentFormatCode: '',
          s_documentFormatDescription: '',
          s_submissionSetId: ''
        }]);
      } catch (e) {
        reject(e);
      }
    });
  }

  public async hl_getdocumentcontent(view: ViewContainerRef, downloadParams: DmpHlGetDocumentContentParams): Promise<DmpHlGetDocumentContentResponse> {
    throw new Error('Method not implemented.');
  }

  public async hl_deletedocument(view: ViewContainerRef, deleteParams: DmpHlDeleteDocumentParams, patientId?: string): Promise<void> {
    return new Promise<void>(async (resolve, reject) => {
      try {
        await this._fakeAwait();
        resolve();
      } catch (e) {
        reject(e);
      }
    });
  }
  hl_deleteArchivedDocument(view: ViewContainerRef, deleteParams: DmpHlDeleteDocumentParams, patientId?: string): Promise<void> {
    return new Promise<void>(async (resolve, reject) => {
      try {
        await this._fakeAwait();
        resolve();
      } catch (e) {
        reject(e);
      }
    });
  }
  public async hl_getDocumentUuidByUniqueId(view: ViewContainerRef, documentInfos: { s_documentUniqueId: string, s_ins: DmpHlFindPatientResponseSIns }): Promise<string> {
    return new Promise<string>(async (resolve, reject) => {
      try {
        await this._fakeAwait();
        resolve('mocked-uuid-123456789');
      } catch (e) {
        reject(e);
      }
    });
  }
  rechercherHistoriqueDeVaccination(view: ViewContainerRef, ins: DmpHlFindPatientResponseSIns): Promise<any> {
    throw new Error('Method not implemented.');
  }

  public async ajouterNoteDeVaccin(view: ViewContainerRef, sendingParam: DmpHlsendDocumentsParams, consumable: VaccinationConsumable, author: VaccinationVaccinator, vaccinator: VaccinationVaccinator, dateInjection: Date, vaccinId?: UpdateNoteVaccinationId, patientId?: string): Promise<any> {
    throw new Error('Method not implemented.');
  }

  public async hl_senddocument(view: ViewContainerRef, sendingParam: DmpHlsendDocumentsParams, document: DmpHlsendDocumentsDocument, documentId?: string, patientId?: string): Promise<void> {
    return new Promise<void>(async (resolve, reject) => {
      try  {
        await this._fakeAwait();
        resolve();
      } catch (e) {
        reject(e);
      }
    });
  }

  public async hl_senddocuments(view: ViewContainerRef, sendingParam: DmpHlsendDocumentsParams, documents: DmpHlsendDocumentsDocument[], documentsId?: Array<string>, patientId?: string): Promise<void> {
    return new Promise<void>(async (resolve, reject) => {
      try  {
        await this._fakeAwait();
        resolve();
      } catch (e) {
        reject(e);
      }
    });
  }

  reinitializeConnector(): Promise<void> {
    throw new Error('Method not implemented.');
  }

  private async _fakeAwait(length = 500): Promise<void> {
    return new Promise<void>(resolve => {
      setTimeout(() => {
        resolve();
      }, length);
    });
  }

  getCisCodes(view: ViewContainerRef): Promise<any> {
    throw new Error('Method not implemented.');
  }

  getAtcCodes(view: ViewContainerRef): Promise<any> {
    throw new Error('Method not implemented.');
  }
  rechercherVaccinAValider(view: ViewContainerRef, ins: DmpHlFindPatientResponseSIns): Promise<any> {
    throw new Error('Method not implemented.');
  }
}
